'use client';

import { useEffect, useState } from "react";
import ContentLoading from "@/components/content-loading";
import Report, { ReportContent } from "@/components/report";

// Only used while a report is still being generated (status 'new' or 'processing').
// Finished reports are rendered on the server — see src/app/reports/[code]/page.tsx.
const ReportPending = ({ contentId, pageSignature }: { contentId: number, pageSignature: string }) => {
  const [content, setContent] = useState<ReportContent | null>(null);

  useEffect(() => {
    const waitForContent = async () => {
      const response = await fetch(`/api/content/${contentId}`);
      const { data, error } = await response.json();
      if (!error && data.status === 'done') {
        setContent(data);
        clearInterval(interval);
      }
    }
    const interval = setInterval(waitForContent, 3000);

    return () => {
      clearInterval(interval);
    }
  }, [contentId]);

  if (!content) {
    return <ContentLoading />
  }

  return <Report content={content} pageSignature={pageSignature} />;
}

export default ReportPending;
